/* tslint:disable */
/* eslint-disable */
/**
 * Property Management API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.0.2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OfferTags
 */
export interface OfferTags {
    /**
     * 
     * @type {number}
     * @memberof OfferTags
     */
    tagId: number;
    /**
     * 
     * @type {string}
     * @memberof OfferTags
     */
    offerTag: string;
}

export function OfferTagsFromJSON(json: any): OfferTags {
    return OfferTagsFromJSONTyped(json, false);
}

export function OfferTagsFromJSONTyped(json: any, ignoreDiscriminator: boolean): OfferTags {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'tagId': json['tagId'],
        'offerTag': json['offerTag'],
    };
}

export function OfferTagsToJSON(value?: OfferTags | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'tagId': value.tagId,
        'offerTag': value.offerTag,
    };
}


